import React from "react";
import { transformVar } from "@quarkly/atomize";
import { createGlobalStyle } from "styled-components";

const pageStyles = {
    "404": {},
    "index": {},
    "bot": {},
    "bot/instrukciya": {},
    "bot/max": {},
    "bot/max/instrukciya": {},
    "bot/prodvizhenie-internet-magazina-v-telegram": {},
    "bot/dlya-chego-sozdat-magazin-v-telegram": {},
    "bot/delayem-magazin-v-telegram": {},
    "bot/prodazha-elektronnykh-tovarov-v-telegram": {},
    "bot/support-bot-magazin": {},
    "bot/uvedomleniya-o-zakazakh-v-magazine-v-telegram": {},
    "bot/onlayn-oplata-v-telegram-magazine": {},
    "bot/poluavtomaticheskiy-priyem-oplaty": {},
    "bot/onlayn-prodazha-tovarov-na-kanalakh-i-gruppakh": {},
    "bot/create-logo": {},
    "bot/prava-na-bot-magazin": {},
    "bot/oformlenie-magazina-v-telegram": {},
    "bot/oplata-kriptoi-v-telegram-magazine": {},
    "instrukciya": {},
    "prodvizhenie-internet-magazina-v-telegram": {},
    "dlya-chego-sozdat-magazin-v-telegram": {},
    "delayem-magazin-v-telegram": {},
    "prodazha-elektronnykh-tovarov-v-telegram": {},
    "support-bot-magazin": {},
    "uvedomleniya-o-zakazakh-v-magazine-v-telegram": {},
    "onlayn-oplata-v-telegram-magazine": {},
    "poluavtomaticheskiy-priyem-oplaty": {},
    "onlayn-prodazha-tovarov-na-kanalakh-i-gruppakh": {},
    "create-logo": {},
    "oformlenie-magazina-v-telegram": {},
    "prava-na-bot-magazin": {},
    "oplata-kriptoi-v-telegram-magazine": {},
    "en": {},
    "en/instrukciya": {}
};

const PageStyles = createGlobalStyle`
    body {
        ${({ styles }) =>
            Object.entries(styles || {}).map(
                ([prop, value]) => `${prop}: ${transformVar(prop, value)};`
            )}
    }
`;
export const GlobalQuarklyPageStyles = ({ pageUrl }) => <PageStyles styles={pageStyles[pageUrl]} />
